import { render, staticRenderFns } from "./TokenImageRender.vue?vue&type=template&id=418a5ab3&scoped=true"
import script from "./TokenImageRender.vue?vue&type=script&lang=ts"
export * from "./TokenImageRender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a5ab3",
  null
  
)

export default component.exports